export const s3 = {
  state: {
    s3Url: null,
    fileDetails: {},
    s3Uploading: false,
    dataLoaded: false,
    headerS3Url: null,
    footerS3Url: null,
    headerFileDetails: {},
    footerFileDetails: {}
  },
  mutations: {
    SET_s3Url(state, s3Url) {
      state.s3Url = s3Url;
    },
    CLEAR_File(state, type) {
       if (type === "header") {
         state.headerS3Url = null;
         state.headerFileDetails = {};
       } else if (type === "footer") {
         state.footerS3Url = null;
         state.footerFileDetails = {};
       } else {
         state.s3Url = null;
         state.fileDetails = {};
       }

       state.s3Uploading = false;
       state.dataLoaded = false;
    },
    SET_fileDetails(state, fileDetails) {
      state.fileDetails = fileDetails;
    },
    SET_s3Uploading(state, s3Uploading) {
      state.s3Uploading = s3Uploading;
    },
    SET_dataLoaded(state, s3Uploading) {
      state.dataLoaded = s3Uploading;
    },
    SET_Header_s3Url(state, headerS3Url){
      state.headerS3Url = headerS3Url;
    },
    SET_Footer_s3Url(state, footerS3Url){
      state.footerS3Url = footerS3Url;
    },
    SET_HeaderFileDetails(state, headerFileDetails){
        state.headerFileDetails = headerFileDetails;
    },
    SET_FooterFileDetails(state, footerFileDetails){
        state.footerFileDetails = footerFileDetails;
    }
  },
  actions: {
    setS3Url: ({ commit, state }, newValue) => {
      commit('SET_s3Url', newValue)
      return state.s3Url
    },
    clearFile: ({ commit }, type = null) => {
      commit('CLEAR_File',type)
    },
    setFileDetails: ({ commit, state }, newValue) => {
      commit('SET_fileDetails', newValue)
      return state.fileDetails
    },
    setS3Uploading: ({ commit, state }, newValue) => {
      commit('SET_s3Uploading', newValue)
      return state.s3Uploading
    },
    setDataLoaded: ({ commit, state }, newValue) => {
      commit('SET_dataLoaded', newValue)
      return state.dataLoaded
    },
    setHeaderS3Url: ({ commit, state }, newValue) => {
      commit('SET_Header_s3Url', newValue)
      return state.headerS3Url
    },
    setFooterS3Url: ({ commit, state }, newValue) => {
      commit('SET_Footer_s3Url', newValue)
      return state.footerS3Url
    },
    setHeaderFileDetails: ({ commit, state }, newValue) => {
      commit('SET_HeaderFileDetails', newValue)
      return state.headerFileDetails
    },
    setFooterFileDetails: ({ commit, state }, newValue) => {
      commit('SET_FooterFileDetails', newValue)
      return state.footerFileDetails
    },
  },
  getters: {
    s3Url: (state) => {
      return state.s3Url
    },
    fileDetails: (state) => {
      return state.fileDetails
    },
    s3Uploading: (state) => {
      return state.s3Uploading
    },
    dataLoaded: (state) => {
      return state.dataLoaded
    },
    headerS3Url: (state) => {
      return state.headerS3Url
    },
    footerS3Url: (state) => {
      return state.footerS3Url
    },
    headerFileDetails: (state) => {
      return state.headerFileDetails
    },
    footerFileDetails: (state) => {
      return state.footerFileDetails
    },
  }
};